import { useEffect } from "react";
import { useCameraContext } from "../features/camera/CameraContext.tsx";
import { ScanResult } from "./useCameraScanner.ts";

/**
 * Hook for listening to scan events from the camera context.
 * Automatically handles subscription and cleanup.
 * 
 * @param callback Function to call when a scan result is received
 */
export function useScanListener(callback: (result: ScanResult) => void) {
  const { addScanListener, removeScanListener } = useCameraContext();
  
  useEffect(() => {
    addScanListener(callback);
    return () => removeScanListener(callback);
  }, [callback, addScanListener, removeScanListener]);
}

/**
 * Hook for listening to error events from the camera context.
 * Automatically handles subscription and cleanup.
 * 
 * @param callback Function to call when an error occurs
 */
export function useErrorListener(callback: (error: string) => void) {
  const { addErrorListener, removeErrorListener } = useCameraContext();
  
  useEffect(() => {
    addErrorListener(callback);
    return () => removeErrorListener(callback);
  }, [callback, addErrorListener, removeErrorListener]);
} 